// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-funnel';

export const Component = () => (
  <path d='M4.502 5C4.156 5 4 5.296 4 5.507a.47.47 0 0 0 .105.296l5.661 5.554.234.279V21l5-4.25v-5.114l.234-.279 5.651-5.542A.481.481 0 0 0 21 5.507c0-.21-.156-.507-.503-.507zm17.16 1.445L16 12v4.5c0 .813-.447 1.055-1 1.5-.553.445-4.447 4-5 4s-1-.448-1-1v-9L3.338 6.445A1.481 1.481 0 0 1 3 5.507C3 4.732 3.609 4 4.502 4h15.995A1.5 1.5 0 0 1 22 5.507c0 .322-.105.651-.338.938z' />
);

export const viewBox = '0 0 25 25';
